module.exports = __webpack_public_path__ + "static/media/aerobot.5aaa704e.png";